import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { HttpClient } from '@angular/common/http';

export const DowngradedAngularCommonModule = angular
  .module('downgraded-angular-common', [])
  .factory('HttpClient', downgradeInjectable(HttpClient)).name;
